import React, {useState, useEffect, useRef} from 'react'
import {piclist} from './piclist'
/*
 */
export default function Pictures() {
  const [index, setIndex] = useState(0)
  const [pic, setPic] = useState(<img alt=""/>)
  const node = useRef(<div/>)
  useEffect(() => {
    node.current.addEventListener('touchstart', swipeStart)
    node.current.addEventListener('touchend', swipeEnd)
  },[])

  const forward = () => {
    setIndex(i => i >= piclist.length -1 ? 0 : i+1)
  }
  const back = () => {
    setIndex(i => i <= 0 ? piclist.length -1 : i-1)
  }

  const FetchPic = () => {
    //console.log("picture",piclist[index],index)
    useEffect(() => {
      function fetchPic() {
        fetch(`./gallery/${piclist[index]}`)
          .then((response) => {return response.blob()})
          .then((myBlob) => {
            let url = URL.createObjectURL(myBlob)
            setPic(<img src={url} alt={piclist[index]} position='absolute'/>)
          })
      }
      fetchPic()
    },[index]) // New picture is fetched on index change.
  }

  // Use swipe on devices that use touch events. Record swipe start, end.
  let sStart = 0,
      sEnd = 0
  const swipeStart = (e) => {
    sStart = e.touches[0].screenX
  }
  // End of swipe is where we decide action.
  const swipeEnd = (e) => {
    sEnd = e.changedTouches[0].screenX
    if (diff(sStart, sEnd) > 45) { // ignore accidental changes
      sStart > sEnd ? forward() : back() // swiped left or right?
    }
  }
  // Difference between start and end of swipe ignoring direction.
  const diff = (start, end) => {
    let df = start > end ? start - end : end - start
    return df
  }

  FetchPic() // Initial picture using index=0

  return(
    <div className="container">
      <div className="picture" ref={node}>
        <span id="previous">
          <span className="chevron left" onClick={back}></span>
        </span>
        <span id="next">
          <span className="next chevron right" onClick={forward}></span>
        </span>
        {pic}
      </div>
    </div>
  )
}
